import { render, staticRenderFns } from "./basicDetailsView.vue?vue&type=template&id=197e3a0c&scoped=true&"
import script from "./basicDetailsView.vue?vue&type=script&lang=js&"
export * from "./basicDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./basicDetailsView.vue?vue&type=style&index=0&id=197e3a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197e3a0c",
  null
  
)

export default component.exports